import React from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb from "./components/Breadcrumb";
import SearchBar from "./components/SearchBar";
import NotificationButton from "./components/NotificationButton";
import UserProfile from "./components/UserProfile";
import { generateBreadcrumbs, getPageTitle } from "./utils/breadcrumbUtils";

/**
 * Admin Header Component
 * Top navigation bar with breadcrumbs, search, notifications, and user profile
 */
const AdminHeader = () => {
  const location = useLocation();
  const breadcrumbs = generateBreadcrumbs(location.pathname);
  const pageTitle = getPageTitle(breadcrumbs);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left Section - Page Title & Breadcrumbs */}
          <div>
            <h1 className="text-2xl font-bold text-gray-800 font-Inter">
              {pageTitle}
            </h1>
            <Breadcrumb breadcrumbs={breadcrumbs} />
          </div>

          {/* Right Section - Search, Notifications, User */}
          <div className="flex items-center space-x-4">
            <SearchBar />
            <NotificationButton />
            <UserProfile />
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
